import { Grid, GridItem, Tag, TagLabel, Text } from "@chakra-ui/react";
import { getStatusColor } from "../../utils/displayGetters";
import { useCampaignInfo } from "./index";

export const CampaignStatusDisplay = () => {
  const { campaign } = useCampaignInfo();
  return (
    // <HStack px={10} pt={2}>
    //   <Text fontWeight={"bold"} fontSize={"sm"} color={"primary.darker"}>
    //     Campaign Status
    //   </Text>
    //   <Tag
    //     size={"sm"}
    //     bg={getStatusColor(campaign.status)}
    //     colorScheme="teal"
    //     borderRadius={"full"}
    //   >
    //     <TagLabel>{campaign.status.toLowerCase()}</TagLabel>
    //   </Tag>
    // </HStack>
    <Grid
      templateColumns="flex"
      gap={2}
      mb={4}
      alignItems={"flex-start"}
    >
      <GridItem colSpan={3}>
        <Text
          color={"primary.darker"}
          fontWeight={"semibold"}
          fontSize={"sm"}
          mr={2}
        >
          Campaign Status:
        </Text>
      </GridItem>
      <GridItem colSpan={5}>
        <Tag
          size={"sm"}
          bg={getStatusColor(campaign.status)}
          colorScheme="teal"
          borderRadius={"full"}
        >
          <TagLabel>{campaign.status.toLowerCase()}</TagLabel>
        </Tag>
      </GridItem>
    </Grid>
  );
};
